module.exports = __webpack_public_path__ + "static/media/Get ready for amazing artist support 2.2ec8e21e.png";